var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59771 0C3.37832 0 2.20888 0.484401 1.34664 1.34664C0.484401 2.20888 0 3.37832 0 4.59771V19.4023C0 21.9429 2.05714 24 4.59771 24H19.4023C21.9429 24 24 21.9429 24 19.4023V4.59771C24 2.05714 21.9429 0 19.4023 0H4.59771ZM1.71429 4.59771C1.71429 3.00514 3.00514 1.71429 4.59771 1.71429H19.4023C20.9949 1.71429 22.2857 3.00514 22.2857 4.59771V19.4023C22.2857 20.9949 20.9949 22.2857 19.4023 22.2857H4.59771C3.83298 22.2857 3.09957 21.9819 2.55882 21.4412C2.01807 20.9004 1.71429 20.167 1.71429 19.4023V4.59771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFalse);
export default __webpack_public_path__ + "static/media/checkbox-false.f50fd54a17217693c0321d27062ecd98.svg";
export { ForwardRef as ReactComponent };